<app-euds-modal
  [visible]="isOpen"
  [heading]="data.title"
  [isCloseable]="true"
  [size]="'default'"
  (onHide)="onCancel()">
  
  <div class="modal-content" slot="content">
    <p>{{ data.message }}</p>
  </div>
  
  <div class="modal-footer" slot="footer">
    <app-euds-button type="secondary" label="{{ data.cancelText }}" (clickEvent)="onCancel()"></app-euds-button>
    <app-euds-button type="primary" label="{{ data.confirmText }}" (clickEvent)="onConfirm()"></app-euds-button>
  </div>
</app-euds-modal>